"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnRendererContextRestored = void 0;
/**
 * @public
 * Emitted when the renderer context is restored. Emitted on both chart and plots.
 */
class OnRendererContextRestored {
    constructor(onRendererContextRestored) {
        this.onRendererContextRestored = onRendererContextRestored;
    }
    static registerListener(chartEventService, onEvent) {
        return chartEventService
            .getCategory(OnRendererContextRestored)
            .addTemporaryListener(new OnRendererContextRestored(onEvent));
    }
    static emit(eventService) {
        const listeners = eventService
            .getCategory(OnRendererContextRestored)
            .getTargets();
        for (let i = 0, iEnd = listeners.length; i < iEnd; ++i) {
            listeners[i].onRendererContextRestored();
        }
    }
}
exports.OnRendererContextRestored = OnRendererContextRestored;
OnRendererContextRestored.callbackKey = "onRendererContextRestored";
//# sourceMappingURL=on-renderer-context-restored.js.map